import { useState, useEffect } from 'react';
import { APP_VERSION } from '../config/version';

export const useAppVersion = () => {
  const [version, setVersion] = useState('...');
  const [isLoading, setIsLoading] = useState(true);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [newVersion, setNewVersion] = useState(null);

  useEffect(() => {
    const getAppVersion = async () => {
      try {
        setIsLoading(true);
        
        // Usar a versão centralizada do config
        let appVersion = APP_VERSION;
        
        // Tentar obter da variável de ambiente se disponível
        if (process.env.REACT_APP_VERSION) {
          appVersion = process.env.REACT_APP_VERSION;
        }
        
        setVersion(appVersion);
      } catch (error) {
        console.error('Erro ao obter versão da aplicação:', error);
        setVersion(APP_VERSION);
      } finally {
        setIsLoading(false);
      }
    };

    getAppVersion();
  }, []);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').then((registration) => {
        // Verificar se há uma atualização aguardando
        if (registration.waiting) {
          setWaitingWorker(registration.waiting);
          setUpdateAvailable(true);
          setNewVersion('Nova versão'); // Pode ser melhorado para obter versão específica
        }

        // Escutar por novas atualizações
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              setWaitingWorker(newWorker);
              setUpdateAvailable(true);
              setNewVersion('Nova versão');
            }
          });
        });

        // Verificar periodicamente por atualizações
        setInterval(() => {
          registration.update();
        }, 60000); // Verificar a cada 1 minuto
      }).catch(error => {
        console.error('Erro ao registrar service worker:', error);
      });

      // REMOVIDO: Auto-reload automático que causava problema no mobile
      // Agora só recarrega quando o usuário clica no banner
    }
  }, []);

  const applyUpdate = () => {
    if (waitingWorker) {
      // Enviar mensagem para o service worker assumir controle
      waitingWorker.postMessage('SKIP_WAITING');
      
      // Aguardar um pouco e então recarregar
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } else {
      // Se não há worker aguardando, apenas recarregar
      window.location.reload();
    }
  };

  return { 
    version, 
    isLoading, 
    updateAvailable, 
    newVersion, 
    applyUpdate,
    formattedVersion: `v${version}`,
    currentVersion: version
  };
};
